import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./LoanSettings')).LoanSettings,
  'loanSettings',
  {
    routeParams: '=',
  },
);
